module.exports = __webpack_public_path__ + "00066012847cbb643ac6d874028da2e9.svg";